<template>
  <div class="col-12">
    <div v-for="node in childrens" :key="node.id">
      
      <div v-if="node.type == 'section' && !node.filtered" class="mt-3 ms-3">
        <ContainerNode :contentTree="this.contentTree" :node="node" :key="node" :title="node.activeTitle" />
      </div>
      
      <div v-else>
        <!--<div v-if="this.contentTree && !this.contentTree.filtered && node.findCurrentVersion">
          <ArticleNode 
            v-if="node.versions.length > 0" 
            :to="'/index.html?article=' + node.id + '&version=' + node.findCurrentVersion().id" 
            :text="!node.findCurrentVersion().title ? node.title : node.findCurrentVersion().title"/>
        </div>-->
        <div v-if="this.contentTree && !this.contentTree.filtered && node.findCurrentVersion">
          <ArticleNode 
            v-if="node.versions.length > 0" 
            :to="{ name: 'article', params: { article: String(node.id), version: node.findCurrentVersion()?.id } }"
            :text="!node.findCurrentVersion().title ? node.title : node.findCurrentVersion().title"/>
        </div>

        <div v-else>
          <div v-for="version in node.versions" :key="String(version.id) + '-' + String(version.filtered)">
            <div v-if="'filtered' in version">
              <div v-if="!version.filtered && node.type == 'content'" class="d-flex content-node-item">
                <ArticleNode 
                  :to="'/index.html?article=' + node.id + '&version=' + version.id" 
                  :text="!version.title ? node.title : version.title"/>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>


<script>
import { defineAsyncComponent } from 'vue';
import { ContentTree } from '../../classes/tree';
import ArticleNode from './ArticleNode.vue';
import ContainerNode from './ContainerNode.vue';

export default {
    name: 'ContentNode',
    components: {
         ContainerNode: defineAsyncComponent(() => import('./ContainerNode.vue')),
        ArticleNode
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },        
        childrens: {
            type: Array,
            required: true
        },
        contentTree: {
            type: ContentTree,
            required: false
        }
    }
}
</script>

<style scoped>
.content-node-item .arrow {
  display: flex;
  align-items: flex-start;
  height: auto !important;
}
.content-node-item .arrow svg {
  flex-shrink: 0;
  margin-right: 0.25rem;
  height: auto;
}
.content-node-item span {
  line-height: 1.2;
}
.content-node-item {
  margin-bottom: 0.5rem; 
}
</style>